<template>
  <Button
    color="primary"
    variant="outlined"
    data-test-id="buy-box-request-date-button"
    class="px-2 rounded-md text-xs grow box-border flex items-center hover:bg-white hover:text-teal-900 relative group h-min border-gray-200 shadow-none!"
    @click="handleClick"
  >
    <PencilStrokeIcon
      class="w-[18px] h-[18px] transition-opacity duration-200 group-hover:opacity-100"
    />
    <PencilFilledIcon
      class="w-[18px] h-[18px] absolute transition-opacity duration-200 opacity-0 group-hover:opacity-100"
    />
    <span class="ml-1 mt-0.5">{{
      $t('product.show.noAvailableDatesBox.ctaTextOnlyProposeDate')
    }}</span>
  </Button>
</template>
<script setup lang="ts">
import PencilStrokeIcon from '~/assets/icons/event/pencil-stroke.svg?component'
import PencilFilledIcon from '~/assets/icons/event/pencil-fill.svg?component'

const { ticketQuantity, requestLocation = 'buybox_header' } = defineProps<{
  /** Set only after the user changes party size in the buy box. */
  ticketQuantity?: number
  /** GTM `request_location` when opening the date-request drawer from this control. */
  requestLocation?: string
}>()

const { toggleDateRequestSidebar } = useUiState()
const route = useRoute()
const emit = defineEmits(['click:request-date'])
const handleClick = () => {
  emit('click:request-date')
  toggleDateRequestSidebar(
    route.name,
    requestLocation,
    undefined,
    ticketQuantity
  )
}
</script>
